export const contactPage = {
  eyebrow: 'Let’s talk about your property',
  title: 'What would you like to create, improve or care for?',
  intro:
    'Tell us about your residential landscape, development site or commercial property. For landscape maintenance and snow removal, we work with businesses and homeowners associations.',
  messageHelper: 'Include your property location and the services you have in mind.',
  office: {
    heading: 'D.A. Alexander & Company, Inc.',
    street: '12711 Farmington Road',
    city: 'Livonia, MI 48150',
    phoneDisplay: '734-427-0030',
    phoneHref: 'tel:+17344270030',
    hours: 'Monday–Friday, 8AM–5PM',
    weekend: 'Saturday–Sunday, closed',
  },
  services: [
    { label: 'Residential landscapes & outdoor living', href: '/residential-landscapes' },
    { label: 'Land development', href: '/land-development' },
    { label: 'Commercial landscape care', href: '/commercial-landscape-care' },
    { label: 'Commercial & seasonal services', href: '/commercial-seasonal-services' },
  ],
};
